import React from 'react';

const ToggleButton = ({id,openId,onClick}) => {
    return (<div className={`toggle-arrow arrow-${openId=== id ? 'up' : 'down'}`} onClick={onClick}></div>)
}

export default ToggleButton;